export default "__VITE_ASSET___ice3Nzt__"